import { EMRdetailsProps } from "@/api_framework/api_modals/EMRs";
import MandatoryLabel from "@/app/components/ui/Reusable/MandatoryLabel";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useEMRtypeAPI } from "@/app/hooks/api_hooks/emr/useEMRtypeAPI";
import { useUpdateTempEMRAPI } from "@/app/hooks/api_hooks/emr/useUpdateTempEMRAPI";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import SwitchMainComponent from "@/app/components/ui/SwitchComponent";
import RBACFlag from "@/app/components/core/RBACFlag";

const TemplateTypeComponent = ({ emrDetails, setEmrDetails, setIsBilable, isBilable }: EMRdetailsProps) => {
  const { execute: updateEmrAPI } = useUpdateTempEMRAPI();
  const { execute: fetchEMRtypeList, emrType } = useEMRtypeAPI();

  const params = new URLSearchParams(location.search);
  const emr_id = params.get("emr_id");

  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {
      emr_template: "",
    },
  });

  useEffect(() => {
    fetchEMRtypeList();
  }, []);

  const EMRTemplateType = emrType?.map((item) => ({
    id: item,
    title: item,
  }));

  useEffect(() => {
    if (emrDetails) {
      formHook.setValue("emr_template", emrDetails?.emr_type);
    }
  }, [emrDetails]);

  const [initialLoad, setInitialLoad] = useState<boolean>(false);

  useEffect(() => {
    if (!initialLoad) {
      setInitialLoad(true);
      return;
    }
    const emrType = formHook.watch("emr_template");

    if (emrType) {
      const constructedBody = {
        emr_status: emrDetails?.emr_status,
        emr_type: emrType,
      };

      updateEmrAPI(emr_id, constructedBody).then(({ status, message }) => {
        if (status) {
          setEmrDetails(message);
        }
      });
    }
  }, [formHook.watch("emr_template")]);

  return (
    <div className="flex items-center justify-between w-full py-3 bg-white p-3 rounded-[10px] mt-3">
      <div className="bg-[#F9FAFB] w-full rounded-xl p-2 flex flex-col sm:flex-row gap-3 sm:gap-2 items-stretch sm:items-center justify-between">
        <div className="flex flex-col sm:flex-row gap-2 sm:items-center min-w-0">
          <h3 className="shrink-0 text-[#656565] font-medium tracking-tight42 text-sm">
            EMR Type <MandatoryLabel label="*" className="text-xs text-[#ED0101] " />{" "}
          </h3>

          <SearchableSelectMenu
            errorMessages={[{ message: "", type: "required" }]}
            onSelectItem={(item) => {
              if (item) {
                formHook.setValue("emr_template", item.title);
              }
            }}
            fieldError={formHook?.formState?.errors?.emr_template}
            register={formHook.register(`emr_template`, { required: true })}
            selectItems={EMRTemplateType}
            placeholder="Select EMR Type"
            showTooltips={true}
            showTypedErrors={true}
            showDropdownIcon={true}
            defaultSelected={EMRTemplateType?.filter((oc) => oc.title === formHook.watch(`emr_template`))[0]}
            listBoxClassName="w-full"
            className="text-[#000000]"
            containerClassName="w-full sm:w-72"
          />
        </div>
        <RBACFlag actionId="EMR_CREATION_BILABLE">
          {" "}
          <SwitchMainComponent
            handelFunction={(state: boolean) => setIsBilable(!state)}
            proimaryText="Billable"
            isBilable={isBilable}
          />
        </RBACFlag>
      </div>
    </div>
  );
};
export default TemplateTypeComponent;
